<template>
  <a-card size="small" :bordered="true" class="chart-card">
    <template slot="title">{{ title }}</template>
    <template v-if="tooltip" slot="extra">
      <a-tooltip :title="tooltip">
        <span class="chart-card__info">i</span>
      </a-tooltip>
    </template>

    <a-skeleton v-if="loading" active :paragraph="{ rows: 6 }" />
    <highcharts v-else :options="options" class="chart-card__chart" />
  </a-card>
</template>

<script>
import { Chart } from 'highcharts-vue';
import { Skeleton } from 'ant-design-vue';

export default {
  name: 'HighchartsCard',

  components: {
    highcharts: Chart,
    'a-skeleton': Skeleton,
  },

  props: {
    title: { type: String, required: true },
    tooltip: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    options: { type: Object, default: () => ({}) },
  },
};
</script>

<style lang="scss" scoped>
.chart-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-card :deep(.ant-card-body) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
}

.chart-card__chart {
  flex: 1;
  min-height: 180px;
}

.chart-card__info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #C8C1BA;
  color: #9C948C;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
}
</style>
